import {accordionScripts} from "./accordion.ts";
import {initScrollToTopButton} from "./back-to-top-button.ts";

window.addEventListener('load', () => {
    accordionScripts();
    initScrollToTopButton();
});